module.exports = __webpack_public_path__ + "media/images/online_talks/test_online_bg-f470717e11ecd53857426ffe09ed33fd.jpg";